module.exports = __webpack_public_path__ + "static/media/chat-icon.b86a69a7.svg";